export enum SwitchViewEnum {
  Floorplan = 'FLOORPLAN',
  List = 'LIST',
  Scheduler = 'SCHEDULER',
  Map = 'MAP',
  Synthesis = 'SYNTHESIS',
}
